<template lang="pug">
v-main
  v-container
    v-card
      v-toolbar.elevation-0
        v-toolbar-title Edit Blocked Email
      v-divider
      v-card-text
        v-form.my-2
          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Domain 
            v-col(cols="5")
              v-text-field(v-model="domain", label="Domain", :rules="[rules.required, rules.validDomain]")

          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader Status
            v-col(cols="5")
              v-radio-group(v-model="isBlocked", row)
                v-radio(label="Blocked", value="blocked")
                v-radio(label="Non Blocked", value="nonblocked")

          v-card-actions.my-8
            v-btn(class="elevation-0 custom__padding-btn" @click="$router.push('/blocked-email')") Back
            v-btn(
              class="custom__padding-btn elevation-0"
              dark
              color="blue-secondary"
              @click="update()"
              :disabled="!formIsValid"
            ) Update

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

const domainRegex = /^@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default {
  name: "Blocked Email Edit",
  data: () => ({
    domain: "",
    isBlocked: "",
    rules: {
      required: (value) => !!value || "This field is required.",
      validDomain: (value) => {
        if (!domainRegex.test(value)) {
          return "Invalid input. Example of valid input : @gmail.com";
        }
      }
    },
    overlay: false,
  }),
  mounted() {
    this.getData(true);
  },
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    formIsValid() {
      return this.domain && domainRegex.test(this.domain);
    },
  },
  methods: {
    getData(isInit) {
      this.overlay = true;
      let token = localStorage.getItem("token");
      axios
        .get(
          process.env.VUE_APP_API +
            `/blocked-email/detail/${this.$route.params.id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.overlay = false;
          this.domain = res.data.data.domain;
          this.isBlocked = (res.data.data.isBlocked && res.data.data.isBlocked === true) ? 'blocked' : 'nonblocked';
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err, { icon: "error" });
        })
        .finally(() => {
          this.overlay = false;
          this.loading = false;
        });
    },
    update() {
      this.overlay = true;
      let token = localStorage.getItem("token");

      const config = {
        method: "put",
        url:
          process.env.VUE_APP_API +
          `/blocked-email/edit/${this.$route.params.id}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {
            domain: this.domain,
            isBlocked: (this.isBlocked === 'blocked') ? true : false
        },
      };

      axios(config)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.$toasted.success("Update data success");
            return this.$router.push("/blocked-email");
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err.response.data.message);
        });
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

div.v-input__prepend-outer {
  display: none !important;
}

div.v-image__image {
  width: 150px;
  height: 150px;
}

div.v-responsive__sizer {
  padding-bottom: 0;
}

.v-image {
  width: 150px;
  height: 150px;
}
</style>